/**
 * E6. Уличные кости: ставка ползунком, правила и риски текстом (ограбление
 * в неспокойном районе, облава там, где игра вне закона). При «пропускать
 * тяжёлое» строки риска скрыты, исход не меняется.
 */
import { t } from '@life/i18n';
import { DICE_ARREST_MIN_AGE, DICE_ARREST_P, DICE_ROBBERY_P, DICE_SEVEN_PAYOUT, type DiceInput, type DiceState } from '@life/minigames';
import type { MinigameScreenProps } from './types';
import { Bet, betCap, useBet } from './ui/Bet';

export function Dice({ state, life, onInput, skipHeavy }: MinigameScreenProps<DiceInput, DiceState>) {
  const cap = betCap(state.maxBet, life.money);
  const [bet, setBet] = useBet(cap);
  const arrestRisk = state.illegal && life.age >= DICE_ARREST_MIN_AGE;

  return (
    <>
      <p class="hint">{t('ui.minigame.dice.rules', { seven: DICE_SEVEN_PAYOUT })}</p>
      {!skipHeavy && state.highCrime && <p class="hint">{t('ui.minigame.dice.risk.robbery', { p: Math.round(DICE_ROBBERY_P * 100) })}</p>}
      {!skipHeavy && arrestRisk && <p class="hint">{t('ui.minigame.dice.risk.arrest', { p: Math.round(DICE_ARREST_P * 100) })}</p>}
      <Bet cap={cap} value={bet} onChange={setBet} />
      <button type="button" class="btn accent block" disabled={bet <= 0} onClick={() => onInput({ bet })}>
        {t('ui.minigame.dice.roll')}
      </button>
    </>
  );
}
